// extracted by mini-css-extract-plugin
export default {"newsItem":"news-item_newsItem__YWibL","image":"news-item_image__2pGO7","content":"news-item_content__ZnWxh","info":"news-item_info__cF6BX"};